const DATA_SAVED = "extragestor/inscripcionesConfirmadas/DATA_SAVED";
const RESET_DATA_SAVED =
  "extragestor/inscripcionesConfirmadas/RESET_DATA_SAVED";

const INSCRIPCIONES_POR_COLEGIO =
  "extragestor/inscripcionesConfirmadas/INSCRIPCIONES_POR_COLEGIO";
const RESET_INSCRIPCIONES_POR_COLEGIO =
  "extragestor/inscripcionesConfirmadas/RESET_INSCRIPCIONES_POR_COLEGIO";

const INSCRIPCIONES_DEL_COLEGIO =
  "extragestor/inscripcionesConfirmadas/INSCRIPCIONES_DEL_COLEGIO";
const RESET_INSCRIPCIONES_DEL_COLEGIO =
  "extragestor/inscripcionesConfirmadas/RESET_INSCRIPCIONES_DEL_COLEGIO";

const OBTENER_DATOS_COLEGIO =
  "extragestor/inscripcionesConfirmadas/OBTENER_DATOS_COLEGIO";
const LIMPIAR_DATOS_COLEGIO =
  "extragestor/inscripcionesConfirmadas/LIMPIAR_DATOS_COLEGIO";

const OBTENER_DATOS_INSCRIPCION =
  "extragestor/inscripcionesConfirmadas/OBTENER_DATOS_INSCRIPCION";
const LIMPIAR_DATOS_INSCRIPCION =
  "extragestor/inscripcionesConfirmadas/LIMPIAR_DATOS_INSCRIPCION";

const APLICAR_FILTROS = "extragestor/inscripcionesConfirmadas/APLICAR_FILTROS";
const RESET_FILTROS = "extragestor/inscripcionesConfirmadas/RESET_FILTROS";

/*---*/
export {
  DATA_SAVED,
  RESET_DATA_SAVED,
  INSCRIPCIONES_POR_COLEGIO,
  RESET_INSCRIPCIONES_POR_COLEGIO,
  INSCRIPCIONES_DEL_COLEGIO,
  RESET_INSCRIPCIONES_DEL_COLEGIO,
  OBTENER_DATOS_COLEGIO,
  LIMPIAR_DATOS_COLEGIO,
  OBTENER_DATOS_INSCRIPCION,
  LIMPIAR_DATOS_INSCRIPCION,
  APLICAR_FILTROS,
  RESET_FILTROS
};



// WEBPACK FOOTER //
// ./src/ducks/confirmadas/types.js